var paletteValues = {
    divider: '#D6D6D6',
    common: {
        black: '#000',
        white: '#fff',
    },
    primary: {
        light: '#417E86',
        main: '#004852',
        dark: '#004852',
        200: '#8CB2B6',
        100: '#CBDDE0',
        50: '#EEF7F9',
        contrastText: '#fff',
    },
    secondary: {
        light: '#FBCBD1',
        main: '#D83B4D',
        dark: '#B51A2C',
        contrastText: '#fff',
    },
    vitality: {
        light: '#FFAF95',
        main: '#FF8D6E',
        dark: '#DC785D',
        contrastText: '#004852',
        200: '#FFCFBF',
        100: '#FFE9E3',
    },
    core: {
        light: '#B3C6C4',
        main: '#8CA7A2',
        dark: '#8CA7A2',
        contrastText: '#004852',
        200: '#D4E0DD',
        100: '#E9EFEE',
    },
    error: {
        light: '#FCEEEE',
        main: '#D83B4D',
        dark: '#B51A2C',
        contrastText: '#fff',
    },
    warning: {
        light: '#FEF5D5',
        main: '#FCDE73',
        dark: '#F2BA2A',
        contrastText: '#000',
    },
    success: {
        light: '#F0FAF2',
        main: '#2B865A',
        dark: '#1D6B45',
        contrastText: '#fff',
    },
    info: {
        light: '#83CDD9',
        main: '#4678CC',
        dark: '#067889',
        contrastText: '#fff',
    },
    grey: {
        300: '#F6F6F6',
        400: '#D6D6D6',
        500: '#9A9A9A',
        600: '#545454',
        900: '#2B2B2B',
        contrastText: '#fff',
    },
    text: {
        primary: '#000',
        secondary: '#545454',
        disabled: '#9A9A9A',
        hint: '#545454',
    },
    background: {
        paper: '#FFFFFF',
        default: '#FBF9F8',
    },
    action: {
        active: '#067889',
        hover: '#EEF7F9',
        selected: '#F6F3EB',
        disabled: 'rgba(0, 0, 0, 0.5)',
        focus: '#E6F5F7',
    },
};
export default paletteValues;
